/* tslint:disable */
/* eslint-disable */
/**
 * FreightSimple Hubble API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { OffsetDateTime } from "@freightsimple/time/branded-types";

import { mapValues } from "../runtime";
import type { EdiOutboundInvoiceKind } from "./EdiOutboundInvoiceKind";
import {
  EdiOutboundInvoiceKindFromJSON,
  EdiOutboundInvoiceKindFromJSONTyped,
  EdiOutboundInvoiceKindToJSON,
  EdiOutboundInvoiceKindToJSONTyped,
} from "./EdiOutboundInvoiceKind";
import type { EdiOutboundInvoiceState } from "./EdiOutboundInvoiceState";
import {
  EdiOutboundInvoiceStateFromJSON,
  EdiOutboundInvoiceStateFromJSONTyped,
  EdiOutboundInvoiceStateToJSON,
  EdiOutboundInvoiceStateToJSONTyped,
} from "./EdiOutboundInvoiceState";

/**
 *
 * @export
 * @interface EdiOutboundInvoiceResponse
 */
export interface EdiOutboundInvoiceResponse {
  /**
   *
   * @type {string}
   * @memberof EdiOutboundInvoiceResponse
   */
  ediOutboundInvoiceId: string;
  /**
   *
   * @type {string}
   * @memberof EdiOutboundInvoiceResponse
   */
  customerInvoiceId: string;
  /**
   *
   * @type {string}
   * @memberof EdiOutboundInvoiceResponse
   */
  invoiceIdentifier?: string | null;
  /**
   *
   * @type {string}
   * @memberof EdiOutboundInvoiceResponse
   */
  shipmentId?: string | null;
  /**
   *
   * @type {EdiOutboundInvoiceKind}
   * @memberof EdiOutboundInvoiceResponse
   */
  kind: EdiOutboundInvoiceKind;
  /**
   *
   * @type {EdiOutboundInvoiceState}
   * @memberof EdiOutboundInvoiceResponse
   */
  state: EdiOutboundInvoiceState;
  /**
   *
   * @type {number}
   * @memberof EdiOutboundInvoiceResponse
   */
  attempts: number;
  /**
   *
   * @type {string}
   * @memberof EdiOutboundInvoiceResponse
   */
  filename?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof EdiOutboundInvoiceResponse
   */
  sentAt?: OffsetDateTime | null;
  /**
   *
   * @type {string}
   * @memberof EdiOutboundInvoiceResponse
   */
  lastError?: string | null;
  /**
   *
   * @type {OffsetDateTime}
   * @memberof EdiOutboundInvoiceResponse
   */
  createdAt: OffsetDateTime;
}

/**
 * Check if a given object implements the EdiOutboundInvoiceResponse interface.
 */
export function instanceOfEdiOutboundInvoiceResponse(
  value: object,
): value is EdiOutboundInvoiceResponse {
  if (
    !("ediOutboundInvoiceId" in value) ||
    value["ediOutboundInvoiceId"] === undefined
  )
    return false;
  if (
    !("customerInvoiceId" in value) ||
    value["customerInvoiceId"] === undefined
  )
    return false;
  if (!("kind" in value) || value["kind"] === undefined) return false;
  if (!("state" in value) || value["state"] === undefined) return false;
  if (!("attempts" in value) || value["attempts"] === undefined) return false;
  if (!("createdAt" in value) || value["createdAt"] === undefined) return false;
  return true;
}

export function EdiOutboundInvoiceResponseFromJSON(
  json: any,
): EdiOutboundInvoiceResponse {
  return EdiOutboundInvoiceResponseFromJSONTyped(json, false);
}

export function EdiOutboundInvoiceResponseFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): EdiOutboundInvoiceResponse {
  if (json == null) {
    return json;
  }
  return {
    ediOutboundInvoiceId: json["ediOutboundInvoiceId"],
    customerInvoiceId: json["customerInvoiceId"],
    invoiceIdentifier:
      json["invoiceIdentifier"] == null ? undefined : json["invoiceIdentifier"],
    shipmentId: json["shipmentId"] == null ? undefined : json["shipmentId"],
    kind: EdiOutboundInvoiceKindFromJSON(json["kind"]),
    state: EdiOutboundInvoiceStateFromJSON(json["state"]),
    attempts: json["attempts"],
    filename: json["filename"] == null ? undefined : json["filename"],
    sentAt: json["sentAt"] == null ? undefined : json["sentAt"],
    lastError: json["lastError"] == null ? undefined : json["lastError"],
    createdAt: json["createdAt"],
  };
}

export function EdiOutboundInvoiceResponseToJSON(
  json: any,
): EdiOutboundInvoiceResponse {
  return EdiOutboundInvoiceResponseToJSONTyped(json, false);
}

export function EdiOutboundInvoiceResponseToJSONTyped(
  value?: EdiOutboundInvoiceResponse | null,
  ignoreDiscriminator: boolean = false,
): any {
  if (value == null) {
    return value;
  }

  return {
    ediOutboundInvoiceId: value["ediOutboundInvoiceId"],
    customerInvoiceId: value["customerInvoiceId"],
    invoiceIdentifier: value["invoiceIdentifier"],
    shipmentId: value["shipmentId"],
    kind: EdiOutboundInvoiceKindToJSON(value["kind"]),
    state: EdiOutboundInvoiceStateToJSON(value["state"]),
    attempts: value["attempts"],
    filename: value["filename"],
    sentAt: value["sentAt"],
    lastError: value["lastError"],
    createdAt: value["createdAt"],
  };
}
